require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-glenvill-projects-appointed-for-sheahan-townhouses.json") })
        }
      }, "path---news-glenvill-projects-appointed-for-sheahan-townhouses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-glenvill-projects-appointed-for-sheahan-townhouses!./.cache/json/news-glenvill-projects-appointed-for-sheahan-townhouses.json
// module id = 817
// module chunks = 231608221292675